const IsRole = (roles, role) => {
  if (roles == undefined || role == undefined) return false;

  if (Array.isArray(role)) {
    return (
      Array.from(roles)
        .map((i) => Array.from(role).includes(i))
        .filter((i) => i == true).length > 0
    );
  }

  return Array.from(roles).includes(role);
};

export default IsRole;
